import {
	PAYMENT_LINK_AWAITING_PAYMENT_STATUSES,
	PaymentLinkStatus,
	PaymentLinkType,
	PaymentMethodEnum,
} from '../enums/openpay.enums';

export interface PaymentLink {
	_id?: string;
	openpayId: string;
	URL: string;
	status: PaymentLinkStatus;
	amount: number;
	financialForm: string;
	paymentLinkType: PaymentLinkType;
	paymentMethod: PaymentMethodEnum | 'cash';
	paidAt?: string;
	reference?: string;
	barcodeUrl?: string;
	clabe?: string;
	bank?: string;
	agreement?: string;
	createdAt?: string;
	updatedAt?: string;
}

export interface PaymentLinkFilterDto {
	financialForm?: string;
	status?: PaymentLinkStatus;
	paymentLinkType?: PaymentLinkType;
	paymentMethod?: PaymentMethodEnum;
	paidAt?: Date;
}

export const PaymentLinkStatusValues: Record<
	PaymentLinkStatus,
	{ title: string; color: string }
> = {
	[PaymentLinkStatus.InProgress]: {
		title: 'Pago en proceso',
		color: 'yellow_100',
	},
	[PaymentLinkStatus.ChargePending]: {
		title: 'Pago pendiente',
		color: 'yellow_100',
	},
	[PaymentLinkStatus.Completed]: {
		title: 'Pago realizado correctamente',
		color: 'green_300',
	},
	[PaymentLinkStatus.Refunded]: {
		title: 'Reembolsado',
		color: 'red_300',
	},
	[PaymentLinkStatus.ChargebackPending]: {
		title: 'Contracargo pendiente',
		color: 'red_300',
	},
	[PaymentLinkStatus.ChargebackAccepted]: {
		title: 'Contracargo aceptado',
		color: 'red_300',
	},
	[PaymentLinkStatus.ChargebackAdjustment]: {
		title: 'Ajuste de contracargo',
		color: 'red_300',
	},
	[PaymentLinkStatus.Cancelled]: {
		title: 'Cancelado',
		color: 'red_300',
	},
	[PaymentLinkStatus.Failed]: {
		title: 'Pago fallido',
		color: 'red_300',
	},
};

export const PaymentLinkTypeValues = {
	[PaymentLinkType.DownPayment]: 'Enganche',
	[PaymentLinkType.PrincipalPayment]: 'Pago a capital',
};

export const PaymentLinkMethodsValues: Record<string, string> = {
	[PaymentMethodEnum.Digital]: 'Pago Digital',
	[PaymentMethodEnum.Store]: 'Pago en Efectivo',
	[PaymentMethodEnum.BankAccount]: 'Pago SPEI',
	cash: 'Pago en Efectivo',
};

export const isPaymentLinkAwaiting = (status: PaymentLinkStatus) =>
	PAYMENT_LINK_AWAITING_PAYMENT_STATUSES.includes(status);

export const isPaymentLinkCompleted = (status: PaymentLinkStatus) =>
	status === PaymentLinkStatus.Completed;

export const getPaymentLinkStatusDisplay = (status: PaymentLinkStatus) =>
	PaymentLinkStatusValues[status] ?? {
		title: status,
		color: 'neutral_600',
	};
